// COM-637 decided the onboarding wizard is not escapable: no close control,
// no Escape, no backdrop dismiss - finishing it is the only way out. That is
// still right for the people it was written for.
//
// It is wrong for an app admin in standalone mode. An admin opening a fresh
// project is not being walked through setup; they are inspecting or fixing
// something, and the wizard locks the whole app behind a questionnaire they
// have no intention of filling in. Embedded sessions are untouched: they
// never auto-open the wizard in the first place (OnboardingGate), and their
// stand-in user is never an admin (AuthContext).
export function canDismissOnboarding(params: { embedded: boolean; isAdmin: boolean }): boolean {
  return !params.embedded && params.isAdmin;
}
